<script>
import {getFormat} from "../helpers/format.helper";
import AlteryxService from "../services/alteryx.service";
import {onMount} from "svelte";
import Loader from "./Loader.svelte";

let metrics = [];
let loadingExport = false;
let filter = '';
let loading = true;
let loadingMetrics = true;
let errorMessage = '';

let sortBy = "organization_metrics.id";
let order = true;
let headers = [
    {title: "KPI ID", key: "organization_metrics.id"},
    {title: "KPI NAME", key: "organization_metrics.title" },
    {title: "BUDGET", key: "organization_metrics.show_budget" },
    {title: "COMPANY", key: "organization"},
    {title: "FORMAT", key: "organization_metrics.format" }
];

onMount( async () => {
    await loadAlteryxCatalog();
});

async function loadAlteryxCatalog() {
    errorMessage = null;
    loading = true;
    metrics = [];

    try {
        loadingMetrics = true;
        const response = await AlteryxService.getMetrics({sortBy, order});

        if (response && response.metrics) {
            metrics = response.metrics;
        }
    } catch (e) {
        console.log(e);
        errorMessage = e.message;
    } finally {
        loading = false;
        loadingMetrics = false;
    }
}

function updateList(e) {
    filter = e.target.value.toString().toLowerCase();
}

function sort(key){
    order = (sortBy === key)? !order : true;
    sortBy = key;
    loadAlteryxCatalog();
}

let exportList = async function(page){
    loadingExport = true;
    try {
        const response = await AlteryxService.export(page);
        if(!response) return false;
        var fields = Object.keys(response[0])
        var replacer = function(key, value) { return value === null ? '' : value }
        var csv = response.map(function(row){
            return fields.map(function(fieldName){
                return JSON.stringify(row[fieldName], replacer)
            }).join(',')
        })
        csv.unshift(fields.join(',')) // add header column
        csv = csv.join('\r\n');
        // Download file
        var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", "alteryx-" + page + ".csv");
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    } catch (e) {
        console.log(e);
        errorMessage = e.message;
    } finally {
        loadingExport = false;
    }
}
</script>
{#if loadingMetrics}
    <Loader fixed={false}></Loader>
{:else}
<div class="row m-0" id="metrics">
    <div class="col-10 px-0 mb-3">
        <div class="input-group mb-0">
            <input type="text" class="form-control" placeholder="Search..." on:keyup={updateList}>
        </div>
    </div>
    <div class="col-2 px-0 mb-3">
        <div class="input-group mb-0 w-auto float-right">
            <button class="btn btn-primary" on:click={() =>exportList('metrics')}>
                {#if loadingExport}
                    <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
                {:else}
                    <img src="/img/csv.svg" alt="csv-icon" class="icon">
                {/if}
                EXPORT
            </button>
        </div>
    </div>
    <div class="col-12 px-0">
        {#if metrics.length > 0}
            <table class="table table-responsive table-scrollable">
                <thead>
                {#each headers as header}
                    <th class="pointer align-top" on:click={() => sort(header.key)}>
                        {header.title}
                        <i class="fa fa-sort-{(sortBy === header.key && !order) ? 'desc' : 'asc' } {(sortBy === header.key) ? 'text-primary' : '' }"></i>
                    </th>
                {/each}
                </thead>
                <tbody>
                {#each metrics as item}
                    {#if filter = '' || item.id.toString().toLowerCase().indexOf(filter) >= 0 || item.title.toString().toLowerCase().indexOf(filter) >= 0
                        || item.organization.toString().toLowerCase().indexOf(filter) >= 0 }
                        <tr>
                            <td id="col-kpis-kpiId">{item.id}</td>
                            <td id="col-kpis-kpiNameColumn">
                                {item.title}
                            </td>
                            <td id="col-kpis-role">{item.show_budget? 'Show': 'Hide'}</td>
                            <td id="col-kpis-organization">{item.organization}</td>
                            <td id="col-kpis-format" >{getFormat(item.format)}</td>
                        </tr>
                    {/if}
                {/each}
                </tbody>
            </table>
        {:else}
            <div class="alert alert-primary">
                <i class="fa fa-info-circle fa-3x text-primary"></i>
                <h4 class="text-primary text-uppercase pt-3">
                    no metrics found!
                </h4>
            </div>
        {/if}
    </div>
</div>
{/if}
